import { Box, Icon, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { ExpensesEntitiesExpensableStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { getStatusLabel } from 'modules/expenses/lib/expensables/statusLabel'
import tagColor from 'modules/expenses/lib/tagColors'

export const Status = ({ status }: { status: string }) => {
  const [open, toggle] = useToggle(false)

  const StatusTooltip = () => {
    if (status === 'reversed') {
      return (
        <Tooltip.Alt
          attachment="bottom center"
          open={open}
          toggle={toggle}
          label={i18n.t('expenses_v2.expense.status.reversedTooltip')}
        >
          <Icon.Small icon="question" encircled="grey800" />
        </Tooltip.Alt>
      )
    }
    return null
  }

  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Box flexDirection="row" alignItems="center" gap="s6" width="s140">
        <Tag showCircle type={tagColor(status)} leftItem="circle">
          {getStatusLabel(status as ExpensesEntitiesExpensableStatusEnum)}
        </Tag>
        <StatusTooltip />
      </Box>
    </Box>
  )
}
